<template>
    <div>
        <v-textarea
            :value="value"
            :label="label"
            :class="noTopMargin ? 'mt-0' : 'mt-3'"
            :rows="rows"
            color="secondary"
            outlined
            dense
            :clearable="clearable"
            hide-details="auto"
            validate-on-blur
            :success="success"
            :disabled="disabled"
            :error-messages="errorMessages"
            :rules="rules"
            :prepend-icon="icons[`${prependIcon}`] || prependIcon"
            :prepend-inner-icon="
                icons[`${prependInnerIcon}`] || prependInnerIcon
            "
            :append-icon="icons[`${appendIcon}`]"
            :append-outer-icon="icons[`${appendOuterIcon}`]"
            @input="$emit('input', $event)"
            @click="$emit('click')"
            @focus="$emit('focus')"
            @blur="$emit('blur')"
        >
            <template v-slot:append>
                <slot name="append"></slot>
            </template>
        </v-textarea>
        <v-row v-if="isSms">
            <v-col
                cols="12"
                md="12"
                class="d-flex justify-center align-center pa-2 mt-0"
            >
                <span class="pr-4">
                    <v-tooltip color="secondary" top>
                        <template v-slot:activator="{ on }">
                            <v-icon
                                class="ma-4 text-subtitle-1 mr-0 pb-1 mt-3"
                                size="35"
                                v-on="on"
                                v-text="icons.mdiAlphabetical"
                            ></v-icon>
                        </template>

                        <span
                            class="font-weight-bold"
                            v-text="translations.totalNoOfChars[lang]"
                        ></span>
                    </v-tooltip>
                    :<span
                        class="ml-1 text-body-1 font-weight-bold text--secondary"
                        >{{ prosmsCharCounter }}</span
                    >
                </span>
                <span>
                    <v-tooltip color="secondary" top>
                        <template v-slot:activator="{ on }">
                            <v-icon
                                v-if="prosmsSmsCounter === 1"
                                class="ma-4 text-subtitle-1 mr-2"
                                size="30"
                                v-on="on"
                                v-text="icons.mdiEmailOutline"
                            ></v-icon
                            ><v-icon
                                v-else
                                class="ma-4 text-subtitle-1 mr-2"
                                size="30"
                                v-on="on"
                                v-text="icons.mdiEmailMultipleOutline"
                            ></v-icon
                        ></template>

                        <span
                            class="font-weight-bold"
                            v-text="translations.totalNoOfSms[lang]"
                        ></span> </v-tooltip
                    >:<span
                        class="ml-1 text-body-1 font-weight-bold text--secondary"
                        >{{ prosmsCharCounter > 0 ? prosmsSmsCounter : 0 }}</span
                    ></span
                >
            </v-col>
        </v-row>
    </div>
</template>

<script>
import {
    mdiEmailOutline,
    mdiEmailMultipleOutline,
    mdiAlphabetical
} from "@mdi/js";
import translations from "@/utils/translations/global";

export default {
    name: "BTextarea",

    mixins: [translations],

    props: {
        value: {
            type: [String, Number]
        },
        type: String,
        label: String,
        prependIcon: String,
        prependInnerIcon: String,
        appendIcon: String,
        appendOuterIcon: String,
        noTopMargin: Boolean,
        success: Boolean,
        isSms: Boolean,
        disabled: Boolean,
        errorMessages: String,
        rules: Array,
        rows: String,
        clearable: {
            type: Boolean,
            default: true
        }
    },

    data: () => ({
        icons: {
            mdiEmailOutline,
            mdiEmailMultipleOutline,
            mdiAlphabetical
        }
    }),

    computed: {
        lang() {
            return this.$route.params.lang;
        },

        prosmsCharCounter() {
            let txt = this.value + "";

            if (!txt?.length) return 0;

            // Set special char that counts as doubles in prosms
            let doubles = ["€", "{", "}", "[", "]", "\\", "~", "^", "|"];

            // Get the length of the text
            // let length = new TextEncoder().encode(txt).length; //($text, 'UTF-8');
            let length =txt.length;

            // Iterate through text and check if there is any char that counts as double and add to the total length of the sms
            [...txt].forEach(c => {
                if (doubles.includes(c)) {
                    length++;
                }
            });

            if (txt.includes("{code}")) length += (txt.split("{code}").length - 1) * 4;

            return length;
        },

        prosmsSmsCounter() {
            return this.prosmsCharCounter > 160
                ? Math.ceil(this.prosmsCharCounter / 153)
                : 1;
        }
    }
};
</script>
